import { Tag } from "antd";

const OrderStatus = {
  created: "Создано",
  active: "Активный",
  canceled: "Отменен",
  confirmed: "Подтвержден",
  sent: "В пути",
  delivered: "Доставлен",
};

export default OrderStatus;




export const StatusSwitcher = (record) => {
  if (record === "created") {
    return <Tag color={"blue"}>{OrderStatus["created"]}</Tag>;
  }
  if (record === "active") {
    return <Tag color={"green"}>{OrderStatus["active"]}</Tag>;
  }
  if (record === "canceled") {
    return <Tag color={"red"}>{OrderStatus["canceled"]}</Tag>;
  }
  if (record === "confirmed") {
    return <Tag color={"#9c54cc"}>{OrderStatus["confirmed"]}</Tag>;
  }
  if (record === "sent") {
    return <Tag color={"orange"}>{OrderStatus["sent"]}</Tag>;
  }
  if (record === "delivered") {
    return <Tag color={"#87d068"}>{OrderStatus["delivered"]}</Tag>;
  }
}


